import { render } from "./CorrNewv2.vue?vue&type=template&id=6a56e8dc"
import script from "./CorrNewv2.vue?vue&type=script&lang=js"
export * from "./CorrNewv2.vue?vue&type=script&lang=js"

import "./CorrNewv2.vue?vue&type=style&index=0&id=6a56e8dc&lang=css"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__